import { useState } from 'react';
import { AlertOptions } from '@/../generated-client/models/AlertOptions';

export interface EmergencyConfigFieldValues {
  specName: string;
  impactDetection: AlertOptions;
  fallDetection: AlertOptions;
  arcFlashDetection: AlertOptions;
}

export function useEmergencyConfigFields(initialValues: EmergencyConfigFieldValues) {
  const [specName, setSpecName] = useState(initialValues.specName);
  const [impactDetection, setImpactDetection] = useState<AlertOptions>(initialValues.impactDetection);
  const [fallDetection, setFallDetection] = useState<AlertOptions>(initialValues.fallDetection);
  const [arcFlashDetection, setArcFlashDetection] = useState<AlertOptions>(initialValues.arcFlashDetection);

  return {
    specName,
    setSpecName,
    impactDetection,
    setImpactDetection,
    fallDetection,
    setFallDetection,
    arcFlashDetection,
    setArcFlashDetection,
  };
}

export type EmergencyConfigFieldsReturn = ReturnType<typeof useEmergencyConfigFields>;
